export enum Roles {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  TUTOR = 'tutor',
  STUDENT = 'student',
}
